import instance from '../../axios';

export const getMerchantList = async (salesID, from, to, type) => {
  const response = await instance.get(
    'merchants/GetAll?id=' +
      salesID +
      '&from=' +
      from +
      '&to=' +
      to +
      '&type=' +
      type
  );
  return response.data;
};
